import React from "react";
import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { usePlatform } from "../platform/store";
import { DataTable, PageRoot, SectionCard, StatusChip, SummaryGrid } from "./ui/PlatformPrimitives";

const ProductComplianceTracker = () => {
  const { products, issues } = usePlatform();
  const rows = products.flatMap((product) =>
    Object.entries(product.compliance.jurisdictions).map(([jurisdiction, entry]) => ({
      productId: product.id,
      productName: product.name,
      jurisdiction,
      status: entry.status,
      blockingIssues: entry.issues.filter((issue) => issue.blocking).length,
      issueCount: entry.issues.length,
      summary:
        jurisdiction === "IFRA"
          ? `${entry.facts.thresholdBreaches} threshold breaches`
          : `${entry.facts.allergens?.length || 0} allergens / ${entry.facts.missingDocuments?.length || 0} gaps`,
    }))
  );

  return (
    <PageRoot>
      <SummaryGrid
        items={[
          ["Rows", rows.length],
          ["Blocking issues", issues.filter((issue) => issue.blocking).length],
          ["EU review", rows.filter((row) => row.jurisdiction === "EU" && row.status !== "Clear").length],
          ["US review", rows.filter((row) => row.jurisdiction === "US" && row.status !== "Clear").length],
        ]}
      />

      <SectionCard eyebrow="Tracker" title="Jurisdiction matrix">
        <DataTable
          columns={[
            { key: "productName", label: "Product", render: (row) => (
              <Link component={RouterLink} to={`/perfume-dashboard?product=${row.productId}`} underline="hover" sx={{ color: "primary.main", fontWeight: 600 }}>
                {row.productName}
              </Link>
            ) },
            { key: "jurisdiction", label: "Jurisdiction" },
            {
              key: "status",
              label: "Status",
              render: (row) => <StatusChip status={row.status} />,
            },
            { key: "blockingIssues", label: "Blocking" },
            { key: "issueCount", label: "Issues" },
            { key: "summary", label: "Summary" },
          ]}
          rows={rows}
          getRowKey={(row) => `${row.productName}-${row.jurisdiction}`}
        />
      </SectionCard>
    </PageRoot>
  );
};

export default ProductComplianceTracker;
